// extracted by mini-css-extract-plugin
module.exports = {"container":"BlueLabel_container__3vo-e","blueFont":"BlueLabel_blueFont__2qTF0"};